
import { SetupContext } from 'vue'

export default {
  name: 'tabSeminar',

  props: {
    list: Array,
    current: Number
  },

  setup(props: any, context: SetupContext) {
    const clickTab = (index: number) => {
      context.emit('click-tab', index)
    }

    return {
      clickTab
    }
  }
}
